module.exports = __webpack_public_path__ + "assets/img/BWIN.c8674b9e.png";